import React, { useState } from "react";
import SeoHead from "../../../../components/SeoHead";
import BulkPaymentHero from "../../services/bulk-payment/BulkPaymentHero";
import WorkSmarter from "../../services/bulk-payment/WorkSmarter";
import WorkPayment from "../../services/bulk-payment/WorkPayment";
import JoinNetwork from "../../services/bulk-payment/JoinNetwork";
import AirtimeModal from "./modal/AirtimeModal";
import img7 from "../../../../assets/img/img7.png";
import svg120 from "../../../../assets/svg/svg120.svg";
import svg121 from "../../../../assets/svg/svg121.svg";
import svg122 from "../../../../assets/svg/svg122.svg";
import svg116 from "../../../../assets/svg/svg116.svg";
import svg108 from "../../../../assets/svg/svg108.svg";
import svg109 from "../../../../assets/svg/svg109.svg";
import svg111 from "../../../../assets/svg/svg111.svg";
import svg112 from "../../../../assets/svg/svg112.svg";
import svg118 from "../../../../assets/svg/svg118.svg";
import svg119 from "../../../../assets/svg/svg119.svg";
import svg98 from "../../../../assets/svg/svg98.svg";


const itemsHero = [
  {
    title: "Instant Top-Ups",
    svg:  svg98 ,
    desc: "Send airtime or data to one or hundreds of recipients in seconds no delays, no errors.",
  },
  {
    title: "Multi-Network Coverage",
    svg: svg118,
    desc: "Support for all major mobile networks. Safaricom, Airtel, and Telkom for seamless nationwide reach.",
  },
  {
    title: "Flexible Disbursement",
    svg: svg119,
    desc: "Allocate top-ups by department, team, or project directly from your Impala Digital Payments wallet.",
  },
];

const itemsSmarter = [
  {
    title: "Multi-Network Support",
    svg: svg120,
    desc: "Digitized petty cash requests and approvals to remove manual handling and delays.",
  },
  {
    title: "Smarter Budgeting",
    svg: svg121,
    desc: "Monitor spending by department, set limits, and stay within budget effortlessly.",
  },
  {
    title: "Fast, Bulk Distribution",
    svg: svg122,
    desc: "Disburse funds instantly to teams and field agents, keeping operations moving.",
  },
  {
    title: "Controlled Disbursements",
    svg: svg116,
    desc: "Gain complete visibility. Every transaction is tracked, approved, and auditable.",
  },
  {
    title: "Real-Time Tracking",
    svg: svg98,
    desc: "Generate detailed reports in seconds for clear, compliant financial reviews.",
  },
];

const itemsWorkPayment = [
  {
    svg: svg108,
    title: "Fund Your Wallet",
    desc: "Add funds via bank transfer or mobile money.",
  },
  {
    svg: svg109,
    title: "Upload Recipients",
    desc: "Add phone numbers manually or import a list via Excel or CSV.",
  },
  {
    svg: svg111,
    title: "Amounts & Networks",
    desc: "Approved requests are funded instantly via wallet or linked account.",
  },
  {
    svg: svg112,
    title: "Send Instantly",
    desc: "Distribute airtime or data bundles and track delivery in real time.",
  },
];

function AirtimePage() {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <SeoHead
        title="Airtime & Data Payments"
        description="Keep your team connected. Distribute airtime and data bundles instantly to any Kenyan network with Impala Digital Payments."
        path="/utility/airtime"
      />
      <BulkPaymentHero
        items={itemsHero}
        title="Keep Your Team Connected, Anytime"
        subtitle="Distribute airtime and data bundles instantly to your staff, agents, or teams across all networks, from one easy-to-use dashboard."
        svg101={img7}
        onCtaClick={() => setOpen(true)}
        ctaLabel="Buy Airtime & Data"
      />
      <WorkSmarter
        items={itemsSmarter}
        title="Built to Make Cash Management Effortless"
        subtitle="Go digital, save time, and stay fully in control of your operational expenses."
      />
      <WorkPayment
        items={itemsWorkPayment}
        title="How Bill Payments & Settlements Work"
        subtitle="Process all your supplier and utility payments in four simple steps"
      />
      <JoinNetwork
        title="Join the growing network of organizations using Impala Digital Payments"
        subtitle="Experience the future of business payments with Impala Digital Payments"
      />
      <AirtimeModal isModalOpen={open} handleCancel={() => setOpen(false)} />
    </div>
  );
}

export default AirtimePage;
